import STORE from '../STORE';
import { API } from '@/utils/api';

const { actions, mutations } = STORE.modules.notifications;
const { mutations: rootMutations } = STORE;

export default {
  namespaced: true,
  state: {
    unreadCounter: 0
  },
  mutations: {
    [mutations.updateUnread]: (state, value) => {
      state.unreadCounter = value;
    }
  },
  actions: {
    [actions.getNotificationsUnreadCount]: async ({ dispatch, commit, state }) => {
      try {
        let response = await API.get('notifications/api/unread_count/');
        commit(mutations.updateUnread, response.data.unread_count)

        return state.unread_counter;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('failed', e.response);
      }
    },

    [actions.getNotificationsList]: async ({ dispatch }) => {
      try {
        let response = await API.get('notifications/api/all_list/?max=50');
        return response.data;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('failed', e.response);
      }
    },

    [actions.makeAllNotificationsRead]: async ({ dispatch }) => {
      return API({
        url: `notifications/mark-all-as-read/`,
        method: 'POST',
        contentType: 'application/json',
        responseType: 'blob'
      });
    },

  },
};
